import * as Schema from 'owa-graph-schema';
import type Extension from 'owa-service/lib/contract/Extension';

export function convertExtensibilityItemToM365PlatformApplication(
    extension: Extension
): Schema.M365PlatformApplication {
    return {
        __typename: 'M365PlatformApplication',
        id: extension.Id || '',
        name: extension.DisplayName || '',
        icon: {
            __typename: 'RemoteImage',
            src: extension.IconUrl || '',
        },
        command: {
            entity: {
                entityId: extension.Id || '',
                type: 'm365_appsideload',
                action: 'default',
            },
            command: {
                visibilityState: 'show',
                stateTransition: 'new',
            },
        },
        isPinnable: false,
    };
}
